import { createAction, props } from "@ngrx/store";

export const stripeCustomerSet = createAction('[Stripe] Set Stripe Customer',
  props<any>()
);
